var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7d3cec;\n      }\n\n      .cls-2 {\n        fill: #7d3bec;\n      }\n\n      .cls-3 {\n        fill: #7c3bec;\n      }\n\n      .cls-4 {\n        fill: #fdfcfe;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.58,95.62c-.12,6.39-1.91,15.27-9.75,15.28l-72.76.14c-7.69.02-10.47-7.75-10.41-13.93.08-9.04,1.23-16.99,7.65-23.26,5.31-6.1,13.68-9.58,22.57-8.85,10.38,4.95,21.96,5.2,32.26-.03,17.58-1.23,30.8,12.43,30.45,30.65Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 91.05,
    cy: 30.25,
    r: 26.94
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168,68.34v15.66s-5.15,3.93-5.15,3.93l-18.2.17c-1.82-11.35-7.65-20.16-18.01-26.47,2.81-2.67,7.14-4.52,11.29-4.56l13.08-.12c8.05-.07,13.93,4.23,16.99,11.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 145.05,
    cy: 34,
    r: 15.34
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.52,87.89c-5.5.12-11.77.19-17.19-.11-6.15-.34-6.03-6.4-6.46-10.69-1.01-10.17,4.27-19.47,15.28-19.92,10.19-.42,20.6-1.42,26.26,4.43-9.7,6.42-16.01,14.02-17.89,26.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 37.04,
    cy: 34,
    r: 15.33
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.7481d90046788c081c6daca90fbd68ca.svg";
export { ForwardRef as ReactComponent };